import api from "../configurations/http-common";

export const getPermissions = async (filter) => {
  let url =
    "?pageNumber=" + filter?.pageNumber + "&pageSize=" + filter?.pageSize;
  return api.securedAxios().get("web/permissions" + url);
};

export const getPermissionDetails = async (id) => {
  let url = "?id=" + id;
  return api.securedAxios().get("web/personPermissionDetails" + url);
};

export const getMenuItems = async () => {
  return api.securedAxios().get("web/menuItems");
};

export const getMenus = async () => {
  return api.securedAxios().get("web/menus");
};

export const createRole = async (payload) => {
  return api.securedAxios().post("web/role", payload);
};

export const getRoles = async () => {
  return api.securedAxios().get("web/roles");
};

export const filterRole = async (filter) => {
  let url =
    "?pageNumber=" + filter?.pageNumber + "&pageSize=" + filter?.pageSize;
  return api.securedAxios().get("web/role/list" + url);
};

export const getRoleById = async (id) => {
  return api.securedAxios().get("web/role/" + id);
};

export const updateRole = async (id, payload) => {
  return api.securedAxios().put("web/role/" + id, payload);
};

export const deleteRole = async (id) => {
  return api.securedAxios().delete("web/role/" + id);
};
